import AppShell from '@common/AppShell/AppShell';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SelfServiceContainer } from './containers/SelfService';

const SelfService = () => {
  const { t } = useTranslation();
  const browserTitle = t('self-service.browser-title');

  // Set above the session gate so the title is right before the agent shows the window and
  // while the session loads. The App launcher navigates within the SPA, so it is handed back on unmount.
  useEffect(() => {
    const previousTitle = document.title;
    document.title = browserTitle;
    return () => {
      document.title = previousTitle;
    };
  }, [browserTitle]);

  return (
    <AppShell translationRoot="self-service">
      <SelfServiceContainer />
    </AppShell>
  );
};

export default SelfService;
